var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_10325_7618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.76906 7.17002C8.66906 6.11002 5.95906 3.46002 3.30906 1.02002L3.05906 0.790016L2.82906 0.630016C2.45906 0.400016 2.33906 0.490016 1.98906 0.740016C1.45906 1.13002 1.52906 1.04002 1.17906 1.60002C1.03906 1.82002 0.959057 2.09002 1.01906 2.35002C1.07906 2.62002 1.13906 2.70002 1.31906 2.89002C1.51906 3.08002 3.74906 5.25002 7.63906 9.46002C7.63906 9.46002 9.58906 11.67 7.46906 12.96C3.92906 15.11 1.92906 15.69 0.389057 16.5C0.129057 16.64 0.0190574 16.82 0.0190574 16.9C-0.0109426 17.08 -0.0409426 17.44 0.0590574 17.74C0.319057 18.5 0.869057 18.85 1.38906 19.45C1.71906 19.84 1.82906 20.01 2.26906 19.76C4.50906 18.52 9.41906 15.99 10.2491 15.51C13.8391 13.47 12.0691 9.40002 9.75906 7.16002L9.76906 7.17002Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10325_7618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.31,
    height: 19.39,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDark);
export default __webpack_public_path__ + "static/media/arrow-right-dark.1b285c36ff7017ecdf19315ffc26fa1f.svg";
export { ForwardRef as ReactComponent };